import { __assign } from "tslib";
import classNames from 'classnames';
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
var TextArea = React.forwardRef(function (props, outerRef) {
    var 
    // html props
    id = props.id, name = props.name, disabled = props.disabled, 
    // custom props
    label = props.label, validation = props.validation, large = props.large, responsive = props.responsive;
    var cleansedProps = __assign(__assign({}, props), { 
        // html props
        id: id !== null && id !== void 0 ? id : label, name: name !== null && name !== void 0 ? name : label, disabled: disabled, 
        // custom props
        label: undefined, validation: undefined, large: undefined, responsive: undefined });
    var innerRef = useRef(null);
    useImperativeHandle(outerRef, function () { return innerRef.current; }, []);
    var _a = useState(''), value = _a[0], setValue = _a[1];
    useEffect(function () {
        setValues(!!props.value ? props.value : props.defaultValue);
    }, [props.defaultValue, props.value]);
    function setValues(temp) {
        if (value !== temp)
            setValue(temp !== null && temp !== void 0 ? temp : '');
        if (!!innerRef.current && innerRef.current.value !== temp)
            innerRef.current.value = temp !== null && temp !== void 0 ? temp : '';
    }
    function onInputHandler(event) {
        var temp = event.currentTarget.value.toString();
        setValues(temp);
    }
    return (React.createElement("div", { className: classNames('fieldValidationWrapper', { responsive: responsive }) },
        React.createElement("div", { className: classNames('inputWrapper textArea text', {
                populated: !!value,
                validation: (validation === null || validation === void 0 ? void 0 : validation.dirty) && (validation === null || validation === void 0 ? void 0 : validation.invalid),
                disabled: disabled,
                large: large,
                responsive: responsive
            }) },
            React.createElement("label", { htmlFor: id !== null && id !== void 0 ? id : label, className: "inputLabel inputText" }, label),
            React.createElement("textarea", __assign({}, cleansedProps, { ref: innerRef, className: "inputTriggerWrapper inputTrigger inputText", style: { whiteSpace: 'normal', minHeight: 'calc(100px - 25px)', resize: disabled ? 'none' : 'vertical' }, onInput: onInputHandler }))),
        !!validation && (React.createElement("div", { className: classNames('fieldValidation fieldErrorMessage', { invisible: !validation.dirty || !validation.invalid }) }, validation.message))));
});
TextArea.displayName = 'TextArea';
export default TextArea;
